<template>
  <section v-for="category in categories" :key="category.id" class="pt-5">
    <div class="container-fluid category-container" :id="category.name">
      <div
        class="row justify-content-center"
        v-if="category.name === 'premium' || category.name === 'group'"
      >
        <HeadingComponent
          class="col-11 col-xl-5 col-xxl-4 no-wrap"
          :title="$t('home.catalog.' + category.name)"
        />
      </div>
      <div class="row justify-content-center" v-else>
        <HeadingComponent
          class="col-11 col-xl-4 col-xxl-3"
          :title="$t('home.catalog.' + category.name)"
        />
      </div>
      <div class="row justify-content-center mb-4">
        <div class="col-11 col-lg-10">
          <p class="category-description text-start fs-4 p-2 mb-4">
            {{ $t("home.catalog." + category.name + "-description") }}
          </p>
        </div>
      </div>
      <div
        class="container-fluid d-none d-lg-block mb-5"
        v-if="category.name === 'perpetual'"
      >
        <div class="row justify-content-center">
          <div class="col-11 col-lg-9">
            <p class="text-start fs-5 p-2 mb-4">
              {{ $t("home.catalog.perpetual-sizes") }}
            </p>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-3">
            <h4>{{ $t('sizes.tall') }}</h4>
          </div>
          <div class="col-3">
            <h4>{{ $t('sizes.grande') }}</h4>
          </div>
          <div class="col-3">
            <h4>{{ $t('sizes.venti') }}</h4>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-3">
            <RoseSizeComponent
              :left="'4,5 cm'"
              :right="'1,7 in'"
              :imgUrl="require('../assets/tall.png')"
              :givenClass="'col-5'"
            />
          </div>
          <div class="col-3">
            <RoseSizeComponent
              :left="'5,0 cm'"
              :right="'1,9 in'"
              :imgUrl="require('../assets/grande.png')"
              :givenClass="'col-5'"
            />
          </div>
          <div class="col-3">
            <RoseSizeComponent
              :left="'6,0 cm'"
              :right="'2,3 in'"
              :imgUrl="require('../assets/venti.png')"
              :givenClass="'col-5'"
            />
          </div>
        </div>
        <div class="row justify-content-center mt-4">
          <div class="col-3">
            <RoseSizeComponent
              :left="'1,7 in'"
              :right="'4,5 cm'"
              :imgUrl="require('../assets/tall-top.png')"
              :givenClass="'col-5'"
            />
          </div>
          <div class="col-3">
            <RoseSizeComponent
              :left="'2,1 in'"
              :right="'5,5 cm'"
              :imgUrl="require('../assets/grande-top.png')"
              :givenClass="'col-5'"
            />
          </div>
          <div class="col-3">
            <RoseSizeComponent
              :left="'2,3 in'"
              :right="'6,0 cm'"
              :imgUrl="require('../assets/venti-top.png')"
              :givenClass="'col-5'"
            />
          </div>
        </div>
      </div>
      <RosesListComponent :category="category.name" />
    </div>
  </section>
</template>

<script>
import HeadingComponent from "./HeadingComponent.vue";
import RosesListComponent from "./RosesListComponent.vue";
import RoseSizeComponent from "./RoseSizeComponent.vue";
export default {
  name: "CategoryComponent",
  components: {
    HeadingComponent,
    RosesListComponent,
    RoseSizeComponent,
  },
  data() {
    return {
      categories: [
        { name: "premium", id: 1 },
        { name: "dyed", id: 2 },
        { name: "group", id: 3 },
        { name: "garden", id: 4 },
        { name: "perpetual", id: 5 },
        { name: "other", id: 6 },
      ],
    };
  },
};
</script>

<style>
.category-description {
  background: #87a8d959;
}

.category-container {
  background: url("../assets/palms.png");
  background-repeat: no-repeat;
  background-size: 60%;
}

.no-wrap {
  white-space: nowrap;
}
</style>
